/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIAssistRequest } from '../models/AIAssistRequest';
import type { AIAssistResponse } from '../models/AIAssistResponse';
import type { AlexandriaCompanyProfile } from '../models/AlexandriaCompanyProfile';
import type { AlexandriaCompanySearchResponse } from '../models/AlexandriaCompanySearchResponse';
import type { AvailableFund } from '../models/AvailableFund';
import type { BulkCreateGenerationJobs } from '../models/BulkCreateGenerationJobs';
import type { ChartDataResponse } from '../models/ChartDataResponse';
import type { CompaniesByFirm } from '../models/CompaniesByFirm';
import type { CompanyDailyNavConfigCurrent } from '../models/CompanyDailyNavConfigCurrent';
import type { CompanyDailyNavConfigUpdate } from '../models/CompanyDailyNavConfigUpdate';
import type { CompanyDailyNavConfigVersion } from '../models/CompanyDailyNavConfigVersion';
import type { CreateFirmRequests } from '../models/CreateFirmRequests';
import type { DailyNavCompLookupResponse } from '../models/DailyNavCompLookupResponse';
import type { DailyNavConfigApplyPreview } from '../models/DailyNavConfigApplyPreview';
import type { DailyNavConfigApplyRequest } from '../models/DailyNavConfigApplyRequest';
import type { DailyNavConfigApplyResponse } from '../models/DailyNavConfigApplyResponse';
import type { DailyNavDeliveryMonitoringResponse } from '../models/DailyNavDeliveryMonitoringResponse';
import type { DailyNavDeliveryReportResponse } from '../models/DailyNavDeliveryReportResponse';
import type { DailyNavFinalizeRequest } from '../models/DailyNavFinalizeRequest';
import type { DailyNavFinalizeResponse } from '../models/DailyNavFinalizeResponse';
import type { DailyNavNoteAttachmentUploadUrl } from '../models/DailyNavNoteAttachmentUploadUrl';
import type { DailyNavRecord } from '../models/DailyNavRecord';
import type { DailyNavRecordGenerateResponse } from '../models/DailyNavRecordGenerateResponse';
import type { DailyNavReportResponse } from '../models/DailyNavReportResponse';
import type { DailyNavReportSourceResponse } from '../models/DailyNavReportSourceResponse';
import type { DailyNavReportTemplateUploadResponse } from '../models/DailyNavReportTemplateUploadResponse';
import type { DailyNavSendResponse } from '../models/DailyNavSendResponse';
import type { DailyNavSetupCompanies } from '../models/DailyNavSetupCompanies';
import type { DailyNavSetupStatus } from '../models/DailyNavSetupStatus';
import type { DailyNavValidationResponse } from '../models/DailyNavValidationResponse';
import type { DashboardAIGenerateRequest } from '../models/DashboardAIGenerateRequest';
import type { DashboardAIGenerateResponse } from '../models/DashboardAIGenerateResponse';
import type { DashboardDataResponse } from '../models/DashboardDataResponse';
import type { ExtendedCompanyInfo } from '../models/ExtendedCompanyInfo';
import type { Firm } from '../models/Firm';
import type { FirmAddUserRequest } from '../models/FirmAddUserRequest';
import type { FirmAddUserResponse } from '../models/FirmAddUserResponse';
import type { FirmCompanies } from '../models/FirmCompanies';
import type { FirmCompaniesRequestsProgress } from '../models/FirmCompaniesRequestsProgress';
import type { FirmCompany } from '../models/FirmCompany';
import type { FirmDailyNavCompanyConfigBulkUpdate } from '../models/FirmDailyNavCompanyConfigBulkUpdate';
import type { FirmDailyNavCompanyConfigList } from '../models/FirmDailyNavCompanyConfigList';
import type { FirmDailyNavConfigUpdate } from '../models/FirmDailyNavConfigUpdate';
import type { FirmDailyNavConfigVersion } from '../models/FirmDailyNavConfigVersion';
import type { FirmDefinitionListResponse } from '../models/FirmDefinitionListResponse';
import type { FirmRequestedDocumentModel } from '../models/FirmRequestedDocumentModel';
import type { FirmRequestsView } from '../models/FirmRequestsView';
import type { FirmStepper } from '../models/FirmStepper';
import type { FirmSummaryDefinition } from '../models/FirmSummaryDefinition';
import type { FirmSummaryRead } from '../models/FirmSummaryRead';
import type { FirmUserPermission } from '../models/FirmUserPermission';
import type { FundByMeasurementDate } from '../models/FundByMeasurementDate';
import type { FundName } from '../models/FundName';
import type { GenerationEffortOptions } from '../models/GenerationEffortOptions';
import type { IntelligenceExcelExport } from '../models/IntelligenceExcelExport';
import type { Investment } from '../models/Investment';
import type { InvestmentCompanyInfo } from '../models/InvestmentCompanyInfo';
import type { RetrieveDocumentGenerationJob } from '../models/RetrieveDocumentGenerationJob';
import type { SummaryDataResponse } from '../models/SummaryDataResponse';
import type { SummaryDefinitionOrder } from '../models/SummaryDefinitionOrder';
import type { UpdateFirmQuestion } from '../models/UpdateFirmQuestion';
import type { UserFirmRole } from '../models/UserFirmRole';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FirmsService {
  /**
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsList(
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FirmUserPermission>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms',
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param data
   * @returns FirmCompany
   * @throws ApiError
   */
  public static apiFirmsCompaniesNewCreate(
    data: FirmCompany,
  ): CancelablePromise<FirmCompany> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/companies/new',
      body: data,
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsCreateFirmQuestionCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/create-firm-question',
    });
  }
  /**
   * @param data
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsCreateFirmRequestedDocumentCreate(
    data: FirmRequestedDocumentModel,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/create-firm-requested-document',
      body: data,
    });
  }
  /**
   * @param data
   * @returns CreateFirmRequests
   * @throws ApiError
   */
  public static apiFirmsCreateRequestsCreate(
    data: CreateFirmRequests,
  ): CancelablePromise<CreateFirmRequests> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/create-requests',
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentRead(
    requestedDocumentId: string,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
    });
  }
  /**
   * @param requestedDocumentId
   * @param data
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentUpdate(
    requestedDocumentId: string,
    data: FirmRequestedDocumentModel,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @param data
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentPartialUpdate(
    requestedDocumentId: string,
    data: FirmRequestedDocumentModel,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentDelete(
    requestedDocumentId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
    });
  }
  /**
   * @param data
   * @returns FirmStepper
   * @throws ApiError
   */
  public static apiFirmsNewCreate(
    data: FirmStepper,
  ): CancelablePromise<FirmStepper> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/new',
      body: data,
    });
  }
  /**
   * @param questionId
   * @returns UpdateFirmQuestion
   * @throws ApiError
   */
  public static apiFirmsQuestionRead(
    questionId: string,
  ): CancelablePromise<UpdateFirmQuestion> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
    });
  }
  /**
   * @param questionId
   * @param data
   * @returns UpdateFirmQuestion
   * @throws ApiError
   */
  public static apiFirmsQuestionUpdate(
    questionId: string,
    data: UpdateFirmQuestion,
  ): CancelablePromise<UpdateFirmQuestion> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
      body: data,
    });
  }
  /**
   * @param questionId
   * @param data
   * @returns UpdateFirmQuestion
   * @throws ApiError
   */
  public static apiFirmsQuestionPartialUpdate(
    questionId: string,
    data: UpdateFirmQuestion,
  ): CancelablePromise<UpdateFirmQuestion> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
      body: data,
    });
  }
  /**
   * @param questionId
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsQuestionDelete(
    questionId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
    });
  }
  /**
   * @param firmId
   * @param fileType
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsAssetSignedUrlRead(
    firmId: string,
    fileType: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/asset-signed-url/{file_type}',
      path: {
        'firm_id': firmId,
        'file_type': fileType,
      },
    });
  }
  /**
   * @param firmId
   * @param date
   * @returns DailyNavRecord
   * @throws ApiError
   */
  public static apiFirmsDailyNavList(
    firmId: string,
    date?: string,
  ): CancelablePromise<Array<DailyNavRecord>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
    });
  }
  /**
   * Does Alexandria already have this comp? Checked before the analyst saves.
   * A backend proxy because Alexandria's API key is server-side. **Read-only** --
   * onboarding happens on save, so `not_found` means "this comp's price history
   * will take a while", not "this comp cannot be added".
   * @param firmId
   * @param companyId
   * @param ticker Cap IQ ticker in EXCHANGE:SYMBOL form, exactly as the comp stores it (for example 'NYSE:MCD'). A bare symbol is rejected: it is not a unique key, and Alexandria matches the qualified form.
   * @returns DailyNavCompLookupResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompaniesAlexandriaCompLookupList(
    firmId: string,
    companyId: string,
    ticker: string,
  ): CancelablePromise<DailyNavCompLookupResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/alexandria/comp-lookup/',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
      query: {
        'ticker': ticker,
      },
    });
  }
  /**
   * The company name and data providers behind an Alexandria ID.
   * Read-only labelling for a link that is otherwise an opaque ID. Defaults to
   * the ID the company's open config carries, and accepts one so the settings
   * page can describe a selection the user has not saved yet.
   * @param firmId
   * @param companyId
   * @param alexandriaId Alexandria profile to describe. Defaults to the one this company's config is linked to; pass an ID to describe an unsaved selection.
   * @returns AlexandriaCompanyProfile
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompaniesAlexandriaProfileList(
    firmId: string,
    companyId: string,
    alexandriaId?: string,
  ): CancelablePromise<AlexandriaCompanyProfile> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/alexandria/profile/',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
      query: {
        'alexandria_id': alexandriaId,
      },
    });
  }
  /**
   * Alexandria companies this company's Daily NAV config could point at.
   * Name and domain default to the company's own. Selecting a result is a normal
   * config save (`alexandria_id` on the config PUT), not a write here.
   * @param firmId
   * @param companyId
   * @param name Name to search for. Defaults to the company's own. Alexandria does not infer aliases, so an alternate name often finds a match.
   * @param domain Domain to resolve exactly, e.g. "stripe.com". Defaults to the company's website. Domain matches rank ahead of name matches.
   * @param limit Maximum candidates to return.
   * @returns AlexandriaCompanySearchResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompaniesAlexandriaSearchList(
    firmId: string,
    companyId: string,
    name?: string,
    domain?: string,
    limit: number = 10,
  ): CancelablePromise<AlexandriaCompanySearchResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/alexandria/search/',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
      query: {
        'name': name,
        'domain': domain,
        'limit': limit,
      },
    });
  }
  /**
   * @param firmId
   * @param companyId
   * @param page A page number within the paginated result set.
   * @returns CompanyDailyNavConfigCurrent
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompaniesConfigList(
    firmId: string,
    companyId: string,
    page?: number,
  ): CancelablePromise<CompanyDailyNavConfigCurrent> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/config/',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param firmId
   * @param companyId
   * @param data
   * @returns CompanyDailyNavConfigVersion
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompaniesConfigUpdate(
    firmId: string,
    companyId: string,
    data: CompanyDailyNavConfigUpdate,
  ): CancelablePromise<CompanyDailyNavConfigVersion> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/config/',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
      body: data,
    });
  }
  /**
   * @param firmId
   * @param companyId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompaniesConfigHistoryList(
    firmId: string,
    companyId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CompanyDailyNavConfigVersion>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/config/history/',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @returns FirmDailyNavCompanyConfigList
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompanyConfigsList(
    firmId: string,
    page?: number,
  ): CancelablePromise<FirmDailyNavCompanyConfigList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/company-configs/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param firmId
   * @param data
   * @returns FirmDailyNavCompanyConfigList
   * @throws ApiError
   */
  public static apiFirmsDailyNavCompanyConfigsUpdate(
    firmId: string,
    data: FirmDailyNavCompanyConfigBulkUpdate,
  ): CancelablePromise<FirmDailyNavCompanyConfigList> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_id}/daily-nav/company-configs/',
      path: {
        'firm_id': firmId,
      },
      body: data,
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @returns FirmDailyNavConfigVersion
   * @throws ApiError
   */
  public static apiFirmsDailyNavConfigList(
    firmId: string,
    page?: number,
  ): CancelablePromise<FirmDailyNavConfigVersion> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/config/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param firmId
   * @param data
   * @returns FirmDailyNavConfigVersion
   * @throws ApiError
   */
  public static apiFirmsDailyNavConfigUpdate(
    firmId: string,
    data: FirmDailyNavConfigUpdate,
  ): CancelablePromise<FirmDailyNavConfigVersion> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_id}/daily-nav/config/',
      path: {
        'firm_id': firmId,
      },
      body: data,
    });
  }
  /**
   * Re-point a NAV day still in progress onto the firm's current config.
   * `GET` previews eligible dates; `POST` performs the re-anchor. Only allowed
   * while the date is strictly before its market's session close. See
   * apps/daily_nav/AGENTS.md ("Mid-day config apply") for the single-firm-version
   * invariant this guards.
   * @param firmId
   * @param page A page number within the paginated result set.
   * @param companyId Scope to a single company's records. Omit to scope to the whole firm day.
   * @returns DailyNavConfigApplyPreview
   * @throws ApiError
   */
  public static apiFirmsDailyNavConfigApplyList(
    firmId: string,
    page?: number,
    companyId?: number,
  ): CancelablePromise<DailyNavConfigApplyPreview> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/config/apply/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'company_id': companyId,
      },
    });
  }
  /**
   * Re-point a NAV day still in progress onto the firm's current config.
   * `GET` previews eligible dates; `POST` performs the re-anchor. Only allowed
   * while the date is strictly before its market's session close. See
   * apps/daily_nav/AGENTS.md ("Mid-day config apply") for the single-firm-version
   * invariant this guards.
   * @param firmId
   * @param data
   * @returns DailyNavConfigApplyResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavConfigApplyCreate(
    firmId: string,
    data: DailyNavConfigApplyRequest,
  ): CancelablePromise<DailyNavConfigApplyResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{firm_id}/daily-nav/config/apply/',
      path: {
        'firm_id': firmId,
      },
      body: data,
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsDailyNavConfigHistoryList(
    firmId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FirmDailyNavConfigVersion>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/config/history/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param firmId
   * @returns DailyNavReportTemplateUploadResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavConfigReportTemplateCreate(
    firmId: string,
  ): CancelablePromise<DailyNavReportTemplateUploadResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{firm_id}/daily-nav/config/report-template/',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * Pull the full Daily NAV monitoring response
   *
   * Everything behind the bank-format report for one finalized NAV day.
   *
   * One entry per monitored company, carrying the inputs as well as the
   * conclusions: every comparable company and private-market provider that fed a
   * delta, the value each contributed and why any was left out, the thresholds each
   * average was judged against, the valuation the day opened from, the price the
   * day reports with its per-holding breakdown, and the review that signed it off.
   * The envelope names the monitoring parameters in force -- resolved from the
   * day's own anchor, not the firm's current settings, because configuration is
   * prospective and a historical day keeps the rules that produced its figures.
   *
   * Figures come from the same code path as the Daily NAV grid, so a pull always
   * agrees with what the analysts reviewed. Market data is pinned to the finalize
   * instant, which makes re-pulling a date return identical numbers.
   *
   * Only finalized days are served. An open day returns 409 `not_finalized` and
   * should be retried once signed off; a date that was never a NAV day returns 404
   * `not_found` and will not succeed on retry.
   *
   * Always send `date`. Omitted, it defaults to the day in progress, which by
   * definition is not signed off yet -- see the parameter description.
   *
   * Not paginated: a NAV day is read whole, since a truncated response would
   * silently under-report the portfolio.
   *
   * Pin the contract with the `X-Scalar-Api-Version` header. Omit it and the
   * current version is served; an unrecognized value is rejected. The current
   * version is named in the API overview.
   *
   * Authentication is by `X-API-Key`. A read-only key is sufficient, and the key's
   * user must have view access to the firm.
   *
   * @param firmId
   * @param date The NAV date to pull, formatted as (YYYY-MM-DD). Defaults to the firm's current effective NAV date, which is derived from its own trading calendar -- so on a weekend or market holiday the default is the last session, not today.
   * @returns DailyNavDeliveryMonitoringResponse
   * @throws ApiError
   */
  public static dailyNavDeliveryMonitoring(
    firmId: string,
    date?: string,
  ): CancelablePromise<DailyNavDeliveryMonitoringResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/delivery/monitoring/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
      errors: {
        401: `The \`X-API-Key\` header is missing, unknown, or inactive. Code \`authentication_failed\`. Terminal: check the key.`,
        403: `The key is valid but its user has no access to this firm. Code \`permission_denied\`. Terminal: ask for a firm grant.`,
        404: `The date was not a NAV day for this firm -- a weekend, a market holiday, or before onboarding. Code \`not_found\`. Terminal: retrying will not create the day.`,
        409: `The day exists but has not been signed off. Code \`not_finalized\`. Transient: retry the same request later.`,
      },
    });
  }
  /**
   * Pull the bank-format Daily NAV report
   *
   * The bank-format Daily NAV report for one finalized NAV day, as JSON.
   *
   * The rows are parsed from the stored CSV artifact -- the same bytes filed with
   * the custodian -- rather than rebuilt from the database, so this payload and the
   * custodian's file can never disagree. `columns` gives the header order; each
   * entry in `rows` is that row keyed by header, with every value the raw string
   * exactly as it appears in the file.
   *
   * Only finalized days are served. An open day returns 409 `not_finalized`: its
   * figures still move and its report can be regenerated, so neither of the
   * guarantees a scheduled pull depends on holds yet. Retry the same request once
   * the day is signed off. A date that was never a NAV day for the firm -- a
   * weekend, a market holiday, or before onboarding -- returns 404 `not_found` and
   * will not succeed on retry.
   *
   * Always send `date`. Omitted, it defaults to the day in progress, which by
   * definition is not signed off yet -- see the parameter description.
   *
   * A finalized day is immutable, so re-pulling a date is safe and returns an
   * identical payload.
   *
   * Pin the contract with the `X-Scalar-Api-Version` header. Omit it and the
   * current version is served; an unrecognized value is rejected. The current
   * version is named in the API overview.
   *
   * Authentication is by `X-API-Key`. A read-only key is sufficient, and the key's
   * user must have view access to the firm.
   *
   * @param firmId
   * @param date The NAV date to pull, formatted as (YYYY-MM-DD). Defaults to the firm's current effective NAV date, which is derived from its own trading calendar -- so on a weekend or market holiday the default is the last session, not today.
   * @returns DailyNavDeliveryReportResponse
   * @throws ApiError
   */
  public static dailyNavDeliveryReport(
    firmId: string,
    date?: string,
  ): CancelablePromise<DailyNavDeliveryReportResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/delivery/report/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
      errors: {
        401: `The \`X-API-Key\` header is missing, unknown, or inactive. Code \`authentication_failed\`. Terminal: check the key.`,
        403: `The key is valid but its user has no access to this firm. Code \`permission_denied\`. Terminal: ask for a firm grant.`,
        404: `Either the date was not a NAV day for this firm (code \`not_found\`) or the finalized day stored no report artifact (code \`no_report\`). Both are terminal for that date; retrying will not produce a file.`,
        409: `The day exists but has not been signed off. Code \`not_finalized\`. Transient: retry the same request later.`,
      },
    });
  }
  /**
   * Export a Daily NAV day as an Excel workbook
   * The Daily NAV grid as an Excel workbook: a Summary sheet, plus one sheet
   * per reviewed company with what its Review Price modal shows.
   * @param firmId
   * @param date
   * @returns binary Daily NAV Excel workbook
   * @throws ApiError
   */
  public static apiFirmsDailyNavExportList(
    firmId: string,
    date?: string,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/export/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
      errors: {
        404: `No Daily NAV records for the requested date.`,
        500: `Unable to export Daily NAV.`,
      },
    });
  }
  /**
   * @param firmId
   * @param data
   * @param date
   * @returns DailyNavFinalizeResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavFinalizeCreate(
    firmId: string,
    data: DailyNavFinalizeRequest,
    date?: string,
  ): CancelablePromise<DailyNavFinalizeResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{firm_id}/daily-nav/finalize/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
      body: data,
    });
  }
  /**
   * @param firmId
   * @param fileType
   * @param page A page number within the paginated result set.
   * @returns DailyNavNoteAttachmentUploadUrl
   * @throws ApiError
   */
  public static apiFirmsDailyNavFinalizeAttachmentsUploadUrlList(
    firmId: string,
    fileType: string,
    page?: number,
  ): CancelablePromise<DailyNavNoteAttachmentUploadUrl> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/finalize/attachments/upload-url/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'file_type': fileType,
      },
    });
  }
  /**
   * @param firmId
   * @param date
   * @returns DailyNavRecordGenerateResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavGenerateCreate(
    firmId: string,
    date?: string,
  ): CancelablePromise<DailyNavRecordGenerateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{firm_id}/daily-nav/generate/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @param date
   * @returns DailyNavReportResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavReportList(
    firmId: string,
    page?: number,
    date?: string,
  ): CancelablePromise<DailyNavReportResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/report/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'date': date,
      },
    });
  }
  /**
   * @param firmId
   * @param date
   * @returns DailyNavReportResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavReportCreate(
    firmId: string,
    date?: string,
  ): CancelablePromise<DailyNavReportResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{firm_id}/daily-nav/report/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @param date
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsDailyNavReportDownloadList(
    firmId: string,
    page?: number,
    date?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/report/download/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'date': date,
      },
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @param date
   * @returns DailyNavReportSourceResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavReportSourceList(
    firmId: string,
    page?: number,
    date?: string,
  ): CancelablePromise<DailyNavReportSourceResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/report/source/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'date': date,
      },
    });
  }
  /**
   * @param firmId
   * @param date
   * @returns DailyNavSendResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavSendCreate(
    firmId: string,
    date?: string,
  ): CancelablePromise<DailyNavSendResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{firm_id}/daily-nav/send/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'date': date,
      },
    });
  }
  /**
   * Each company's opening valuation and its GPC comps, for the setup wizard.
   * @param firmId
   * @returns DailyNavSetupCompanies
   * @throws ApiError
   */
  public static apiFirmsDailyNavSetupCompaniesList(
    firmId: string,
  ): CancelablePromise<DailyNavSetupCompanies> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/setup/companies/',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * Whether Daily NAV setup is finished, for the resume banner.
   * @param firmId
   * @returns DailyNavSetupStatus
   * @throws ApiError
   */
  public static apiFirmsDailyNavSetupStatusList(
    firmId: string,
  ): CancelablePromise<DailyNavSetupStatus> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/setup/status/',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @param date
   * @returns DailyNavValidationResponse
   * @throws ApiError
   */
  public static apiFirmsDailyNavValidateList(
    firmId: string,
    page?: number,
    date?: string,
  ): CancelablePromise<DailyNavValidationResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/daily-nav/validate/',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'date': date,
      },
    });
  }
  /**
   * @param firmId
   * @param companyId
   * @returns InvestmentCompanyInfo
   * @throws ApiError
   */
  public static apiFirmsFundInvestmentRead(
    firmId: string,
    companyId: string,
  ): CancelablePromise<InvestmentCompanyInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/fund-investment/{company_id}',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
    });
  }
  /**
   * @param firmId
   * @returns FirmRequestsView
   * @throws ApiError
   */
  public static apiFirmsQuestionsAndRequestedDocumentsRead(
    firmId: string,
  ): CancelablePromise<FirmRequestsView> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/questions-and-requested-documents',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * @param firmId
   * @returns FirmCompaniesRequestsProgress
   * @throws ApiError
   */
  public static apiFirmsRequestsProgressRead(
    firmId: string,
  ): CancelablePromise<FirmCompaniesRequestsProgress> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/requests-progress',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * @param firmPk
   * @param page A page number within the paginated result set.
   * @returns CompaniesByFirm A list of CompaniesByFirm objects
   * @throws ApiError
   */
  public static apiFirmsCompaniesListList(
    firmPk: string,
    page?: number,
  ): CancelablePromise<Array<CompaniesByFirm>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_pk}/companies-list/',
      path: {
        'firm_pk': firmPk,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * * Used in invite user ledger of portfolio app
   * * It's not meant as a way to rewrite UserFirmRole information, this will fail if the user is already in the firm
   * @param firmPk
   * @param data
   * @returns FirmAddUserResponse
   * @throws ApiError
   */
  public static apiFirmsUsersUpdate(
    firmPk: string,
    data: FirmAddUserRequest,
  ): CancelablePromise<FirmAddUserResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_pk}/users',
      path: {
        'firm_pk': firmPk,
      },
      body: data,
    });
  }
  /**
   * * Used in invite user ledger of portfolio app
   * * It's not meant as a way to rewrite UserFirmRole information, this will fail if the user is already in the firm
   * @param firmPk
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUsersPartialUpdate(
    firmPk: string,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{firm_pk}/users',
      path: {
        'firm_pk': firmPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUsersUpdate1(
    firmPk: string,
    userPk: string,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_pk}/users/{user_pk}',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUsersPartialUpdate1(
    firmPk: string,
    userPk: string,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{firm_pk}/users/{user_pk}',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsUsersDelete(
    firmPk: string,
    userPk: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/{firm_pk}/users/{user_pk}',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns UserFirmRole
   * @throws ApiError
   */
  public static apiFirmsUsersRolesUpdate(
    firmPk: string,
    userPk: string,
    data: UserFirmRole,
  ): CancelablePromise<UserFirmRole> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns UserFirmRole
   * @throws ApiError
   */
  public static apiFirmsUsersRolesPartialUpdate(
    firmPk: string,
    userPk: string,
    data: UserFirmRole,
  ): CancelablePromise<UserFirmRole> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this firm.
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsRead(
    id: number,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this firm.
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUpdate(
    id: number,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this firm.
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsPartialUpdate(
    id: number,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsCompaniesList(
    id: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FirmCompanies>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/companies',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @param cId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsCompanyRead(
    id: string,
    cId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ExtendedCompanyInfo>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/company/{c_id}',
      path: {
        'id': id,
        'c_id': cId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this fund.
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsFundsList(
    id: number,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FundName>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/funds',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * SCAL-9352 role-aware effort options: the server computes exactly what
   * the current user may see so the frontend never embeds a tier/model table.
   * Standard users get options truncated at the firm max (fastest-only firms
   * hide the selector); staff get all five with beyond_firm_max flags;
   * superusers additionally get model names and the raw advanced models.
   * @param id
   * @returns GenerationEffortOptions
   * @throws ApiError
   */
  public static apiFirmsGenerationEffortOptionsList(
    id: string,
  ): CancelablePromise<GenerationEffortOptions> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/generation-effort-options',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns RetrieveDocumentGenerationJob
   * @throws ApiError
   */
  public static apiFirmsGenerationJobsBulkCreate(
    id: string,
    data: BulkCreateGenerationJobs,
  ): CancelablePromise<Array<RetrieveDocumentGenerationJob>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/generation-jobs/bulk',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        409: `Generation target changed after validation; reconcile requested company IDs with created_jobs before retrying.`,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsHasSummaryRead(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/has-summary',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns any Indicates if the firm has summary data
   * @throws ApiError
   */
  public static apiFirmsHasSummaryCreate(
    id: string,
    data: FundByMeasurementDate,
  ): CancelablePromise<{
    has_summary?: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/has-summary',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param date Optional date filter in YYYY-MM-DD format
   * @param fundId Optional fund ID filter
   * @param breakevenMultiple Optional breakeven multiple (e.g., 1.0, 1.25, 2.0)
   * @returns Investment A list of Investments scoped to the firm
   * @throws ApiError
   */
  public static apiFirmsInvestmentsRead(
    id: string,
    date?: string,
    fundId?: number,
    breakevenMultiple?: string,
  ): CancelablePromise<Array<Investment>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/investments',
      path: {
        'id': id,
      },
      query: {
        'date': date,
        'fund_id': fundId,
        'breakeven_multiple': breakevenMultiple,
      },
    });
  }
  /**
   * @param id
   * @param date Optional date filter in YYYY-MM-DD format
   * @param fundId Optional fund ID filter
   * @param breakevenMultiple Optional breakeven multiple (e.g., 1.0, 1.25, 2.0)
   * @returns FirmSummaryRead
   * @throws ApiError
   */
  public static apiFirmsSummaryRead(
    id: string,
    date?: string,
    fundId?: number,
    breakevenMultiple?: string,
  ): CancelablePromise<FirmSummaryRead> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary',
      path: {
        'id': id,
      },
      query: {
        'date': date,
        'fund_id': fundId,
        'breakeven_multiple': breakevenMultiple,
      },
      errors: {
        400: `Invalid date format`,
      },
    });
  }
  /**
   * @param id
   * @param page A page number within the paginated result set.
   * @returns FirmDefinitionListResponse
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsList(
    id: string,
    page?: number,
  ): CancelablePromise<FirmDefinitionListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsCreate(
    id: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/summary-definitions',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns AIAssistResponse
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsAiAssistCreate(
    id: string,
    data: AIAssistRequest,
  ): CancelablePromise<AIAssistResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/summary-definitions/ai-assist',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Invalid request`,
        503: `AI service unavailable`,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns DashboardAIGenerateResponse
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsDashboardAiGenerateCreate(
    id: string,
    data: DashboardAIGenerateRequest,
  ): CancelablePromise<DashboardAIGenerateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/summary-definitions/dashboard-ai-generate',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Invalid request`,
        422: `The prompt could not be turned into a valid dashboard`,
        503: `AI service unavailable`,
      },
    });
  }
  /**
   * @param id
   * @param measurementDate
   * @returns AvailableFund
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsFundsList(
    id: string,
    measurementDate?: string,
  ): CancelablePromise<Array<AvailableFund>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions/funds',
      path: {
        'id': id,
      },
      query: {
        'measurement_date': measurementDate,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns SummaryDefinitionOrder
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsOrderUpdate(
    id: string,
    data: SummaryDefinitionOrder,
  ): CancelablePromise<SummaryDefinitionOrder> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}/summary-definitions/order',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns SummaryDefinitionOrder
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsOrderPartialUpdate(
    id: string,
    data: SummaryDefinitionOrder,
  ): CancelablePromise<SummaryDefinitionOrder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}/summary-definitions/order',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsRead(
    id: string,
    definitionId: string,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsUpdate(
    id: string,
    definitionId: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsPartialUpdate(
    id: string,
    definitionId: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsDelete(
    id: string,
    definitionId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param fundId Optional fund ID to scope chart series to a single fund so the popover trend matches the fund-filtered table row.
   * @returns ChartDataResponse
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsChartDataRead(
    id: string,
    definitionId: string,
    fundId?: number | null,
  ): CancelablePromise<ChartDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions/{definition_id}/chart-data',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      query: {
        'fund_id': fundId,
      },
      errors: {
        400: `Invalid request`,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param measurementDate
   * @param fundId Optional fund ID to scope the aggregation to a single fund.
   * @returns DashboardDataResponse
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsDashboardDataRead(
    id: string,
    definitionId: string,
    measurementDate?: string,
    fundId?: number | null,
  ): CancelablePromise<DashboardDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions/{definition_id}/dashboard-data',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      query: {
        'measurement_date': measurementDate,
        'fund_id': fundId,
      },
      errors: {
        400: `Not a dashboard definition, or invalid measurement date / fund`,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param measurementDate
   * @param fundId Optional fund ID to scope rows before applying definition filters and sort keys.
   * @returns SummaryDataResponse
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsDataRead(
    id: string,
    definitionId: string,
    measurementDate?: string,
    fundId?: number | null,
  ): CancelablePromise<SummaryDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions/{definition_id}/data',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      query: {
        'measurement_date': measurementDate,
        'fund_id': fundId,
      },
      errors: {
        400: `Invalid measurement date or filter type mismatch`,
      },
    });
  }
  /**
   * Export an Intelligence summary as a styled Excel workbook
   * @param id
   * @param definitionId
   * @param data
   * @returns binary Intelligence summary Excel workbook
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsExcelExportCreate(
    id: string,
    definitionId: string,
    data: IntelligenceExcelExport,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/summary-definitions/{definition_id}/excel-export',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
      errors: {
        400: `Dashboards cannot be exported to Excel, or the payload is invalid.`,
      },
    });
  }
  /**
   * Firm valuations page data endpoint. Separate URL and definition namespace
   * from the intelligence page; same underlying data source for now.
   *
   * Override get() when a valuations-specific data service is needed.
   * @param id
   * @param date Optional date filter in YYYY-MM-DD format
   * @param fundId Optional fund ID filter
   * @param breakevenMultiple Optional breakeven multiple (e.g., 1.0, 1.25, 2.0)
   * @returns FirmSummaryRead
   * @throws ApiError
   */
  public static apiFirmsValuationsRead(
    id: string,
    date?: string,
    fundId?: number,
    breakevenMultiple?: string,
  ): CancelablePromise<FirmSummaryRead> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/valuations',
      path: {
        'id': id,
      },
      query: {
        'date': date,
        'fund_id': fundId,
        'breakeven_multiple': breakevenMultiple,
      },
      errors: {
        400: `Invalid date format`,
      },
    });
  }
  /**
   * @param id
   * @param page A page number within the paginated result set.
   * @returns FirmDefinitionListResponse
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsList(
    id: string,
    page?: number,
  ): CancelablePromise<FirmDefinitionListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/valuations-definitions',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsCreate(
    id: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/valuations-definitions',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns AIAssistResponse
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsAiAssistCreate(
    id: string,
    data: AIAssistRequest,
  ): CancelablePromise<AIAssistResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/valuations-definitions/ai-assist',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Invalid request`,
        503: `AI service unavailable`,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns DashboardAIGenerateResponse
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsDashboardAiGenerateCreate(
    id: string,
    data: DashboardAIGenerateRequest,
  ): CancelablePromise<DashboardAIGenerateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/valuations-definitions/dashboard-ai-generate',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Invalid request`,
        422: `The prompt could not be turned into a valid dashboard`,
        503: `AI service unavailable`,
      },
    });
  }
  /**
   * @param id
   * @param measurementDate
   * @returns AvailableFund
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsFundsList(
    id: string,
    measurementDate?: string,
  ): CancelablePromise<Array<AvailableFund>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/valuations-definitions/funds',
      path: {
        'id': id,
      },
      query: {
        'measurement_date': measurementDate,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns SummaryDefinitionOrder
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsOrderUpdate(
    id: string,
    data: SummaryDefinitionOrder,
  ): CancelablePromise<SummaryDefinitionOrder> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}/valuations-definitions/order',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns SummaryDefinitionOrder
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsOrderPartialUpdate(
    id: string,
    data: SummaryDefinitionOrder,
  ): CancelablePromise<SummaryDefinitionOrder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}/valuations-definitions/order',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsRead(
    id: string,
    definitionId: string,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsUpdate(
    id: string,
    definitionId: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsPartialUpdate(
    id: string,
    definitionId: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsDelete(
    id: string,
    definitionId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param fundId Optional fund ID to scope chart series to a single fund so the popover trend matches the fund-filtered table row.
   * @returns ChartDataResponse
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsChartDataRead(
    id: string,
    definitionId: string,
    fundId?: number | null,
  ): CancelablePromise<ChartDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}/chart-data',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      query: {
        'fund_id': fundId,
      },
      errors: {
        400: `Invalid request`,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param measurementDate
   * @param fundId Optional fund ID to scope the aggregation to a single fund.
   * @returns DashboardDataResponse
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsDashboardDataRead(
    id: string,
    definitionId: string,
    measurementDate?: string,
    fundId?: number | null,
  ): CancelablePromise<DashboardDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}/dashboard-data',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      query: {
        'measurement_date': measurementDate,
        'fund_id': fundId,
      },
      errors: {
        400: `Not a dashboard definition, or invalid measurement date / fund`,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param measurementDate
   * @param fundId Optional fund ID to scope rows before applying definition filters and sort keys.
   * @returns SummaryDataResponse
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsDataRead(
    id: string,
    definitionId: string,
    measurementDate?: string,
    fundId?: number | null,
  ): CancelablePromise<SummaryDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}/data',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      query: {
        'measurement_date': measurementDate,
        'fund_id': fundId,
      },
      errors: {
        400: `Invalid measurement date or filter type mismatch`,
      },
    });
  }
  /**
   * Export an Intelligence summary as a styled Excel workbook
   * @param id
   * @param definitionId
   * @param data
   * @returns binary Intelligence summary Excel workbook
   * @throws ApiError
   */
  public static apiFirmsValuationsDefinitionsExcelExportCreate(
    id: string,
    definitionId: string,
    data: IntelligenceExcelExport,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/valuations-definitions/{definition_id}/excel-export',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
      errors: {
        400: `Dashboards cannot be exported to Excel, or the payload is invalid.`,
      },
    });
  }
}
